import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Widget from "../UI/Widget/Widget";
import WidgetHeader from "../UI/Widget/WidgetHeader";
import WidgetRefreshButton from "../Presentational/Widgets/WidgetRefreshButton";
import ReportLoader from "./ReportLoader";
import ReportDataTable from "./ReportDataTable";
import ReportChart from "./ReportChart";
import ErrorList from "../UI/ErrorDetail/ErrorList";
import { AlertError, AlertInfo } from "../UI/StandardAlerts/StandardAlerts";
// The page size to use when the report is being rendered into a grid. For charts, this will not be
// used - the report's page size setting will be used in the case of chart rendering mode.
const PAGE_SIZE = 10;
const ReportDisplay = (props) => {
    if (!props.filter || !props.dashboardWidget) {
        return "";
    }
    const displayParam = props.dashboardWidget.dashboardWidgetParams &&
        props.dashboardWidget.dashboardWidgetParams.find((dwp) => dwp.key === "reportDisplay");
    if (displayParam &&
        displayParam.value === "chart" &&
        !props.isRunningFilter) {
        if (props.filter.chartType &&
            props.reportData &&
            props.filter.filterChartSettings) {
            // @ts-expect-error - TS2786 - 'ReportChart' cannot be used as a JSX component.
            return _jsx(ReportChart, Object.assign({}, props));
        }
        if (!props.isRunningFilter) {
            return (_jsxs(_Fragment, { children: [_jsx("div", { className: "card-body", children: _jsx(AlertInfo, { message: "There is no chart configured for this report." }) }), _jsx(ReportDataTable, Object.assign({ bordered: false, pagingContainerClassName: "ml-2 mb-2" }, props))] }));
        }
        return "";
    }
    if (!props.isRunningFilter) {
        return (_jsx(ReportDataTable, Object.assign({ bordered: false, pagingContainerClassName: "ml-2 mb-2" }, props)));
    }
    return "";
};
const DashboardReportContainer = (props) => {
    if (!props.dashboardWidget.dashboardWidgetParams) {
        console.log("No dashboardWidgetParams");
        return _jsx(AlertError, { message: "No Dashboard Widget Parameter" });
    }
    const reportIdParam = props.dashboardWidget.dashboardWidgetParams.find((dwp) => dwp.key === "reportId");
    if (!reportIdParam) {
        console.log("No reportIdParam");
        return _jsx(AlertError, { message: "No Report Id Parameter" });
    }
    const filterId = parseInt(reportIdParam.value, 10);
    let usePageSize = PAGE_SIZE;
    const displayParam = props.dashboardWidget.dashboardWidgetParams &&
        props.dashboardWidget.dashboardWidgetParams.find((dwp) => dwp.key === "reportDisplay");
    if (displayParam && displayParam.value === "chart") {
        usePageSize = 50;
    }
    return (
    // @ts-expect-error - TS2786 - 'ReportLoader' cannot be used as a JSX component.
    _jsx(ReportLoader, { filterId: filterId, pageSize: usePageSize, runNow: true, 
        // @ts-expect-error - TS2322 - Type '({ filter, filterConditions, setFilterConditionProps, runFilter, isRunningFilter, reportData, hasNextPage, pageIndex, prevPage, nextPage, orderBy, sort, errors, clearErrors, getFilterRunRequest, validationErrors, }: { filter: Filter | null | undefined; filterConditions: FilterCondition[]; setFilterConditionProps: (f...' is not assignable to type '(arg1: { filter: Filter | null | undefined; filterConditions: FilterCondition[]; setFilterConditionProps: (fc: FilterCondition, value: string, displayValue: string, valueType: string, relativeOption: string) => void; ... 12 more ...; validationErrors: string[]; }) => Node'.
        render: ({ filter, filterConditions, setFilterConditionProps, runFilter, isRunningFilter, reportData, hasNextPage, pageIndex, prevPage, nextPage, orderBy, sort, errors, clearErrors, getFilterRunRequest, validationErrors, }) => {
            if (!filter) {
                return "";
            }
            return (_jsxs(Widget, { children: [_jsx(WidgetHeader, { title: filter.name, children: _jsx("div", { className: "text-nowrap ml-2", children: _jsx(WidgetRefreshButton, { isLoading: isRunningFilter, onRefresh: runFilter }) }) }), _jsxs("div", { className: "custom-scrollbar", style: { overflow: "auto" }, children: [_jsx(ErrorList, { errors: errors, onClear: clearErrors, errorDetailClassName: "mx-3" }), _jsx(ReportDisplay, { dashboardWidget: props.dashboardWidget, filter: filter, hasNextPage: hasNextPage, isRunningFilter: isRunningFilter, onNextPageClick: nextPage, onPrevPageClick: prevPage, onSort: sort, orderBy: orderBy, pageIndex: pageIndex, reportData: reportData })] })] }));
        } }));
};
export default DashboardReportContainer;
